import React from 'react';

// Thin filled bar + "Step X of Y · label" — scales to any number of steps,
// unlike the older horizontal label-strip which crowds past ~4.
export function ProgressBar({ current, total, label }) {
  const pct = Math.min(100, Math.max(0, ((current - 1) / (total - 1 || 1)) * 100));
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-xs">
        <span className="font-medium text-foreground">
          Step {current} of {total}
        </span>
        <span className="text-muted-foreground">{label}</span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
      >
        <div
          className="h-full rounded-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
